module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<input type="text" class="lb-url full-width" placeholder="http://example.com"/>\n<div class="zmags-input-control small columns">\n    <div class="pull-left">\n        <label data-unit="px">Width:  <input type="number" step="any" class="lb-width"></label>\n    </div>\n    <div class="pull-right">\n        <label data-unit="px">Height: <input type="number" step="any" class="lb-height"></label>\n    </div>\n</div>\n';
 if (descriptor.type !== "url") { ;
__p += '\n<span class="help-block">\n    <em>Lightboxed ' +
__e( descriptor.type ) +
'</em>: <a class="embedded">' +
__e( descriptor.id );
 if (descriptor.scene > 1) { ;
__p += ', scene ' +
__e( descriptor.scene ) +
' ';
 } ;
__p += '</a>\n</span>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/lightbox/LightboxActionPropertiesView.tpl
// module id = 1712
// module chunks = 0